import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ChevronDown } from 'lucide-react';
import { cn } from '@/lib/utils';
import { SIDEBAR_PRODUCT_ITEMS } from '@/components/layout/sidebar/sidebar-config';

interface SidebarProductsProps {
  productsOpen: boolean;
  onToggle: () => void;
  isActive: (path: string) => boolean;
}

export function SidebarProducts({ productsOpen, onToggle, isActive }: SidebarProductsProps) {
  const { t } = useTranslation('dashboard');
  return (
    <div className="border-t border-border">
      <button
        type="button"
        onClick={onToggle}
        className="flex items-center justify-between w-full px-4 py-2 text-[10px] font-bold uppercase tracking-widest text-muted-foreground hover:text-muted-foreground"
      >
        {t('shell.products')}
        <ChevronDown className={cn('h-3 w-3 transition-transform', !productsOpen && '-rotate-90')} />
      </button>
      {productsOpen && (
        <div className="px-2 pb-2 space-y-0.5">
          {SIDEBAR_PRODUCT_ITEMS.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={cn(
                'flex items-center gap-2 rounded-control px-2 py-1.5 text-xs font-medium transition-colors',
                isActive(item.path) ? 'bg-secondary text-secondary-foreground' : 'text-muted-foreground hover:text-foreground hover:bg-muted',
              )}
            >
              <div className="relative">
                <item.icon className="h-3.5 w-3.5 shrink-0" />
                {item.dotColor && (
                  <span className="absolute -right-0.5 -top-0.5 h-1.5 w-1.5 rounded-full" style={{ background: item.dotColor }} />
                )}
              </div>
              <span>{item.label}</span>
            </NavLink>
          ))}
        </div>
      )}
    </div>
  );
}
